import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useSearchParams } from 'react-router-dom';
import { classOptionsAction } from 'redux/action/classAction';
import { customerOptionsAction } from 'redux/action/customerAction';
import { getEmployeeAction } from 'redux/action/employeeAction';
import { getEmployeeCostColumnAction } from 'redux/action/employeeCostColumnSlice';
import { getPayrollSummaryReportAction } from 'redux/action/reportsAction';
import { AppDispatch } from 'redux/store';
import { useDebounce } from 'use-debounce';
import { hasText } from 'utils/utils';
import SearchAndFilter from './SearchAndFilter';
import PayrollSummaryTable from './Table';
import styles from './index.module.scss';
import { getConfiguration } from 'redux/action/configurationAction';
import { locationOptionsAction } from 'redux/action/locationAction';
// type Props = {};

const PayrollSummaryReport = (props: any) => {
	const {
		setSelectedPayPeriod,
		selectedPayPeriod,
		searchValue,
		setSearchValue,
		filterValue,
		setFilterValue,
		setQueryParams,
	} = props;

	const dispatch = useDispatch<AppDispatch>();
	// const [queryParams, setQueryParams] = useSearchParams();
	// const [selectedPayPeriod, setSelectedPayPeriod] = useState<string | null>(
	// 	queryParams.get('payPeriod') || localStorage.getItem('payPeriod') || null
	// );

	// const [searchValue, setSearchValue] = useState<string>('');
	const [debounceSearchValue] = useDebounce(searchValue, 1000);
	const [applySearch, setApplySearch] = useState<boolean>(false);
	// const [filterValue, setFilterValue] = useState<any>({});

	const { payRollPayPeriodId } = useSelector((state: any) => state.reports);

	const { selectedCompanyDetails } = useSelector(
		(state: any) => state.companies
	);

	// const [pageNo, setPageNo] = useState(1);
	// const [isInViewPort, setIsInViewPort] = useState<boolean>(false);
	useEffect(() => {
		dispatch(classOptionsAction());
		dispatch(customerOptionsAction());
		dispatch(locationOptionsAction());
		dispatch(getEmployeeAction());
		getPayrollSummaryReportData();
	}, []);

	useEffect(() => {
		if (selectedPayPeriod || payRollPayPeriodId) {
			dispatch(
				getEmployeeCostColumnAction({
					payPeriodId: selectedPayPeriod || payRollPayPeriodId,
				})
			);
			dispatch(
				getConfiguration({
					payPeriodId: selectedPayPeriod,
				})
			);
		}
	}, [selectedPayPeriod, payRollPayPeriodId]);

	useEffect(() => {
		if (selectedCompanyDetails) {
			setFilterValue((prev: any) => ({
				...prev,
				employeeId: [],    // Reset employee dropdown
				customerId: [],    // Reset customer dropdown
				classId: []        // Reset class dropdown
			}));

			dispatch(classOptionsAction());
			dispatch(customerOptionsAction());
			dispatch(locationOptionsAction());
			dispatch(getEmployeeAction());
			setSelectedPayPeriod(null);
			setApplySearch(true);
		}
	}, [selectedCompanyDetails]);

	useEffect(() => {
		if (applySearch) {
			getPayrollSummaryReportData();
		}
	}, [
		selectedPayPeriod,
		debounceSearchValue,
		filterValue,
		selectedCompanyDetails,
	]);

	useEffect(() => {
		if (payRollPayPeriodId) {
			setSelectedPayPeriod(payRollPayPeriodId);
		}
	}, [payRollPayPeriodId]);

	const getPayrollSummaryReportData = async () => {
		const query: any = {
			search: searchValue,
			payPeriodId: selectedPayPeriod,
			...filterValue,
		};

		// Handle employeeId as array - convert to comma-separated string for API
		if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
			query.employeeId = query.employeeId.join(',');
		} else {
			delete query.employeeId;
		}

		// Handle customerId as array - convert to comma-separated string for API
		if (Array.isArray(query.customerId) && query.customerId.length > 0) {
			query.customerId = query.customerId.join(',');
		} else {
			delete query.customerId;
		}

		// Handle classId as array - convert to comma-separated string for API
		if (Array.isArray(query.classId) && query.classId.length > 0) {
			query.classId = query.classId.join(',');
		} else {
			delete query.classId;
		}

		if (!hasText(searchValue)) {
			delete query.search;
		}

		await dispatch(getPayrollSummaryReportAction(query));
	};

	const handlePayPeriod = (payPeriodId: string) => {
		setApplySearch(true);
		setSelectedPayPeriod(payPeriodId);
		setQueryParams({ payPeriod: payPeriodId });
	};

	const performFilterHandler = (key: string, value: any) => {
		setFilterValue({ ...filterValue, [key]: value });
		setApplySearch(true);
	};

	const clearFilter = () => {
		setApplySearch(true);
		setSearchValue('');
		setFilterValue({});
	};

	const performSearchHandler = (value: string) => {
		setSearchValue(value);
		setApplySearch(true);
	};

	return (
		<div>
			<div className={styles['payroll-summary__header']}>
				<SearchAndFilter
					handlePayPeriod={handlePayPeriod}
					selectedPayPeriod={selectedPayPeriod}
					performFilterHandler={performFilterHandler}
					performSearchHandler={performSearchHandler}
					clearFilter={clearFilter}
					searchValue={searchValue}
					filterValue={filterValue}
				/>
			</div>
			<div className={styles['payroll-summary__table']}>
				<PayrollSummaryTable
					searchValue={searchValue}
					filterValue={filterValue}
				/>
			</div>
		</div>
	);
};

export default PayrollSummaryReport;
